import React from "react";
import {
  Flex,
  Text,
  Button,
  Provider,
  Segment,
  Form,
  FormInput,
} from "@fluentui/react-northstar";
import Constants from "../../../constants/text-constants";
import PasswordTextInput from "../../atoms/PasswordTextInput";

const SignInDialog = (props) => {
  const {
    username,
    password,
    onChange,
    signInClicked,
    forgotPasswordClicked,
  } = props;

  return (
    <Provider.Consumer
      render={(theme) => (
        <Segment
          className={"signin-dialog segment " + theme.siteVariables.themeString}
          id="signInDialog"
          data-testid="signInDialog"
        >
          <Form className="sign-in-form" data-testid="signInForm">
            <Flex space="evenly" fill column hAlign="center" vAlign="center">
              <Text id="title" className="title" content={Constants.SIGN_IN} />
              <Flex column gap="gap.medium">
                <FormInput
                  autoFocus
                  className="credentials"
                  id="username"
                  data-testid="username"
                  value={username}
                  placeholder={Constants.USERNAME}
                  onChange={(e) => onChange(e.target.id, e.target.value)}
                />
                <PasswordTextInput
                  className="credentials"
                  id="password"
                  data-testid="password"
                  value={password}
                  placeholder={Constants.PASSWORD}
                  onChange={(e) => onChange(e.target.id, e.target.value)}
                />
              </Flex>
              <Button
                id="signInBtn"
                data-testid="signInBtn"
                onClick={signInClicked}
                content={Constants.SIGN_IN}
                primary
              />
              <Button
                data-testid="forgotPasswordBtn"
                text
                content={Constants.FORGOT_YOUR_PASSWORD}
                onClick={forgotPasswordClicked}
                className="non-selectable"
              />
            </Flex>
          </Form>
        </Segment>
      )}
    ></Provider.Consumer>
  );
};

export default SignInDialog;
